import React, { useEffect, useState } from "react";
import { Ad, AdLocation } from "../types";
import AdItemMedium from "./items/ad/medium";
import withRedux from "../withRedux";
import { NavLink } from "react-router-dom";
import adSelector from "../selectors/adSelector";

function selectAd(ads: Ad[]): Ad | null {
	if (ads.length > 0) {
		return ads[Math.floor(Math.random() * ads.length)];
	}
	return null;
}

const AdWidget = ({
	ads,
	className,
	rotate,
}: {
	ads: Ad[];
	className?: string;
	location: AdLocation;
	rotate: boolean;
}) => {
	const [ad, setAd] = useState(null as Ad);

	useEffect(() => {
		if (!rotate || !ads) {
			return;
		}

		setAd(selectAd(ads));
	}, [rotate, ads]);

	if (className === null) {
		className = "aBlock";
	}

	return <AdDisplay ad={ad} className={className} />;
};

export const AdDisplay = ({ ad, className }: { ad: Ad; className?: string }) => {
	if (!ad) {
		return null;
	}
	return ad.campaign ? (
		<NavLink to={`/campaign/${ad.campaign}`} className={className} data-campaign={ad.campaign}>
			<AdItemMedium ad={ad} />
		</NavLink>
	) : (
		<a href={ad.link} className={className} target="_blank" rel="noopener noreferrer">
			<AdItemMedium ad={ad} />
		</a>
	);
};

const mapStateToProps = ({ deals: { ads, rotate } }, ownProps) => {
	const { location } = ownProps;
	return { ads: adSelector(ads, location, null), rotate };
};

export default withRedux({}, mapStateToProps)(AdWidget);
